import React, { useState, useEffect, useContext, useRef } from "react";
import moment from "moment";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
import { isImmediateNonLedForBlockCart } from "../../../../../utils/getProposalAvailableFromLabel";
import { Button, notification, Modal, Input, Select } from "antd";
import mainContext from "../context/MainContext/mainContext";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "../../../../toolkit/slices/cart/cartSlice";
import { useNavigate } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import Share from "../../../containers/ShareToOtherPlatforms/index";
import handleDownloadExcel from "../utils/handleDownloadExcel";
import generatePresentation from "../utils/generatePresentation";
import { WhatsappIcon } from "react-share";
import "react-quill/dist/quill.snow.css";
const FileInput = ({
  data,
  isOpen,
  index,
  ind,
  setOk,
  propId,
  setIsEditable,
  entirePropData,
  client,
  PR,
  setPR,
  downloadAllowed,
  excelURL,
  setExcelURL,
  pptURL,
  setPptURL,
}) => {
  const { setInventories, setProposalId, setShowLoader, apiBaseUrl, setSendingLoader } =
    useContext(mainContext);

  const [bodyOfEmail, setBodyOfEmail] = useState("");
  const [modalVisibleEmail, setModalVisibleEmail] = useState(false);
  let userId = useSelector((state) => state.user._id);
  const cart = useSelector((state) => state.cartSpace.cart);
  const [subject, setSubject] = useState("Proposal");
  const [selectedEmails, setSelectedEmail] = useState(null);
  const [emailOptions, setEmailOptions] = useState([]);
  const [inputEmail, setInputEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const shareButtonRef = useRef(null);

  const { Option } = Select;
  const displayClientName =
    entirePropData?.clientName ?? entirePropData?.client?.name;
  const modules = {
    toolbar: [
      [
        { bold: true },
        { italic: true },
        { underline: true },
        { link: true },
        { emoji: true },
      ],
    ],
  };

  const formats = ["bold", "italic", "underline", "link", "emoji"];
  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };
  const handleInputConfirm = () => {
    if (inputEmail && !selectedEmails.includes(inputEmail)) {
      setSelectedEmail([...selectedEmails, inputEmail]);
      setInputEmail("");
    }
  };
  const handleEmailSelect = (selectedItems) => {
    setSelectedEmail(selectedItems);
  };
  const handleCancelEmail = () => {
    setModalVisibleEmail(false);
  };
  const handleTextArea = (value) => {
    setBodyOfEmail(value);
    console.log("This vallll", value);
  };
  const saveEmailIfItsNew = async (emails) => {
    let newEmails = emails.filter((ele) => !emailOptions.includes(ele));
    let requestBody = {
      emails: newEmails,
    };
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/saveNewEmails`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJSON = response.json();
      if (response.ok) {
        console.log(responseJSON.message);
      }
    } catch (err) {
      notification.error({ message: err.message, duration: 0.3 });
    }
  };
  const handleOkEmail = async () => {
    try {
      let source = "";

      if (userId == "6655da0d21d3e92d1b400e27") {
        source = "sales@yellowspot.in";
      } else if (userId == "6655d9b40777525410c88982") {
        source = "aksha.shah@yellowspot.in";
      } else if (userId == "6655da0db7fa235637d8803a") {
        source = "mediaplanning@yellowspot.in";
      } else if (userId == "668bb8a8dc1b17763bfc16bd") {
        source = "pankaj.vyas@yellowspot.in";
      } else if (userId == "668bb8a98846df09d6649fc3") {
        source = "meet.javia@yellowspot.in";
      } else if (userId == "668bb8a86a5e8031326ead83") {
        source = "saurabh.sharma@yellowspot.in";
      } else if (userId == "6655d9b40777525410c88982") {
        source = "aksha.shah@yellowspot.in";
      } else if (userId == "6655da0d21d3e92d1b400e27") {
        source = "sales@yellowspot.in";
      }
      console.log("this is theeeee data", data);
      const requestBody = {
        subject,
        email: selectedEmails,
        finalUrl1: pptURL,
        finalUrl2: excelURL,
        source,
        userId,
        bodyOfEmail,
      };

      const response = await fetch(
        `${apiBaseUrl}/autosend/sendEmailForYellowSpotForWeb`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data1 = await response.json();
      if (data1.success) {
        notification.success({ message: "Email has been sent successfully" });
        await saveEmailIfItsNew(selectedEmails);
        // await generateEmailSrNo();
        navigate("/approvals");
      } else {
        notification.error({ message: data1.message });
      }
    } catch (error) {
      notification.error({ message: error.message });
    }
    setModalVisibleEmail(false);
  };
  useEffect(() => {
    setBodyOfEmail(`<p>Dear Sir,</p>
      <br/>
      <p>Please find below the links to download the proposal documents:</p>
      <br/>
      <br/>
      <p><a href="${encodeURI(pptURL)}">Download PowerPoint presentation</a></p>
      <br/>
      <br/>
      <p><a href="${encodeURI(excelURL)}">Download Excel file</a></p>
      <br/>
      <br/>
      <p>Awaiting your positive response for the same.</p>
      <br/>
      <p>Best regards,</p>
      <br/>
      <p>Yellow Spot</p>
      <br/>
     `);
  }, [excelURL, pptURL]);
  const handleWhatsappShare = async (
    proposals,
    clientName,
    PR,
    proposalData
  ) => {
    setSendingLoader(true);
    await Promise.all([
      handleDownloadExcel(
        clientName,
        proposals,
        PR,
        proposalData,
        true,
        setShowLoader,
        setExcelURL
      ),
      generatePresentation(
        proposals,
        clientName,
        PR,
        proposalData,
        true,
        setShowLoader,
        setPptURL,
        userId
      )
    ])
    setSendingLoader(false);
  };

  useEffect(() => {
    async function fetchEmails() {
      try {
        let response = await fetch(
          `${apiBaseUrl}/inventoryManagement/listEmails`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        let responseJson = await response.json();
        let emails = responseJson?.emails?.map((ele) => ele.emailId) || [];
        setEmailOptions(emails);
      } catch (error) {
        console.error("Error fetching emails:", error);
      }
    }
    fetchEmails();
  }, []);
  const handleEmail = async (proposals, clientName, PR, proposalData) => {
    setSendingLoader(true);
    // Using Promise.all to run both functions concurrently
    await Promise.all([
      handleDownloadExcel(
        clientName,
        proposals,
        PR,
        proposalData,
        true,
        setShowLoader,
        setExcelURL
      ),
      generatePresentation(
        proposals,
        clientName,
        PR,
        proposalData,
        true,
        setShowLoader,
        setPptURL,
        userId
      ),
    ]);
    setSendingLoader(false);
    // Setting modal visibility to true after both promises have resolved
    setModalVisibleEmail(true);
  };

  const handleBlockInventoriesToCart = () => {
    const inCart = new Set((cart || []).map((c) => c._id));
    const toAdd = [];
    (data?.proposals || []).forEach((p) => {
      const inv = p?.invId;
      if (!inv?._id || !isImmediateNonLedForBlockCart(inv)) return;
      if (inCart.has(inv._id)) return;
      toAdd.push(inv);
      inCart.add(inv._id);
    });
    if (toAdd.length === 0) {
      notification.info({
        message: "Nothing to add",
        description:
          "No non-LED inventories with Immediate availability, or they are already in the cart.",
      });
      return;
    }
    toAdd.forEach((inv) => dispatch(addToCart(inv)));
    notification.success({
      message: `${toAdd.length} inventory(s) added to cart`,
      duration: 2,
    });
  };

  function handleView(data) {
    setInventories(
      data.proposals.map((ele) => ({
        _id: ele._id,
        rpm: ele.rpm,
        mountingCharge: ele?.mountingCharge,
        printingCharge: ele?.printingCharge,
        specialRate: ele?.specialRate,
        innovationRate: ele?.innovationRate || 0,
        locationArea: ele?.invId?.locations?.name,
        invId: ele?.invId?._id,
      }))
    );
    setProposalId(propId);
    setOk((prev) => !prev);
    setIsEditable(false);
    setPR(data?.packageRate);
  }

  return (
    <>
      <div
        className={`proposal-list fileInput ${isOpen[ind] ? "" : "stacked-prop"
          }`}
      >
        <div className="proposal-date">
          <div className="proposal-date-child">
            <span>{moment(data.createdAt).format("MMM")}</span>
            <span>{moment(data.createdAt).format("DD")}</span>
            <span>{moment(data.createdAt).format("ddd")}</span>
          </div>
          <span className="date-vertical-border"></span>
        </div>
        <div>
          <div></div>
          <div style={{ whiteSpace: "nowrap" }}>
            Proposal ID: #{Number(index) + 1}{" "}
            <span
              style={{
                fontSize: "14px",
                color: `${data.status == "accepted" ? "green" : "orange"}`,
              }}
            >
              {data.status}
            </span>
          </div>
          <div>By {data.createdBy.name}</div>
        </div>
        <div className="proposal-info-dt">
          {data.packageRate ? (
            <div className="proposal-info-dt-child">
              <span>Package Rate</span>
              <div>₹ {formatIndianNumber(data.packageRate)}</div>
            </div>
          ) : (
            data.totalProposalPrice !== 0 && (
              <div className="proposal-info-dt-child">
                <span>Amount</span>
                <div>₹ {formatIndianNumber(data.totalProposalPrice)}</div>
              </div>
            )
          )}
          <div className="proposal-info-dt-child">
            <span>Inventory Count</span>
            <div>({data.proposals.length})</div>
          </div>
        </div>
        {downloadAllowed && (
          <div
            className="proposal-download-spec"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <Button
                onClick={() => {
                  console.log("data: ", data);
                  handleDownloadExcel(
                    displayClientName,
                    data.proposals,
                    data.packageRate,
                    data,
                    false,
                    setShowLoader
                  );
                }}
              >
                EXCEL
              </Button>
              <Button
                onClick={() => {
                  generatePresentation(
                    data.proposals,
                    displayClientName,
                    PR,
                    data,
                    false,
                    setShowLoader,
                    setPptURL,
                    userId
                  );
                }}
              >
                PPT
              </Button>
            </div>

            <div
              style={{ marginLeft: "2rem", cursor: "pointer" }}
              onClick={async () => {
                await handleWhatsappShare(
                  data.proposals,
                  displayClientName,
                  PR,
                  data
                );
                if (shareButtonRef.current) {
                  shareButtonRef.current.click();
                }
              }}
            >
              <WhatsappIcon size={32} round />
            </div>
            <div style={{ position: "absolute", visibility: "hidden" }}>
              <Share ref={shareButtonRef} pptLink={pptURL} excelLink={excelURL} />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                margin: "1.5rem",
              }}
            >
              <Button
                type="primary"
                onClick={() => {
                  handleEmail(
                    data.proposals,
                    displayClientName,
                    PR,
                    data
                  );
                }}
              >
                Email
              </Button>
              <Button onClick={handleBlockInventoriesToCart}>
                Block inventories
              </Button>
            </div>
            <style>
              {`
        .custom-modal-email .ant-modal-content {
          border-radius: 1% !important; /* Rounded corners */
          width: 596px !important; /* Fixed width */
          height: 615px !important; /* Fixed height */
          max-width: 100% !important; /* Ensure responsiveness */
          max-height: 100% !important; /* Ensure responsiveness */
          overflow: hidden; /* Hide overflow to maintain rounded corners */
          padding:0px
        }
        .custom-modal-email .ant-modal-header,
        .custom-modal-email .ant-modal-footer {
          border-radius: 20% 20% 0 0 !important; /* Rounded corners for header */
        }
        .custom-modal-email .ant-modal-close {
          border-radius: 50% !important; /* Optional: Round the close button */
        }
        .custom-modal-email .ant-modal-body {
          padding: 0px !important; /* Remove padding */
        }
        .custom-modal-email .ant-modal-content {
          border-radius: 1% !important;
          width: 596px !important;
          height: 615px !important;
          max-width: 100% !important;
          max-height: 100% !important;
          overflow: hidden !important;
          padding: 0px !important;
        }
        .custom-modal-email .custom-close-button {
          position: absolute;
          top: 4px; /* Adjust position */
          right: 12px; /* Adjust position */
          background: transparent;
          border: none;
          cursor: pointer;
          font-size: 18px; /* Size of the icon */
          color: #444746; /* Color of the icon */
          z-index: 1000; /* Ensure it’s on top */

        }
        .custom-modal-email .custom-close-button:hover,
        .custom-modal-email .custom-close-button:focus {
          color: #000 !important; /* Ensure color remains the same on hover and focus */
          background: transparent !important; /* Ensure background remains transparent */
          box-shadow: none !important; /* Remove any shadow */
          border: none !important; /* Remove any border */
        }
        .ant-select-selector.custom-dropdown {
        

          /* Add any additional custom styles here */
        }
      
      `}
            </style>
            <Modal
              visible={modalVisibleEmail}
              onOk={handleOkEmail}
              onCancel={handleCancelEmail}
              className="custom-modal-email" // Apply the custom class
              // This controls the padding of the outer modal wrapper
              footer={null}
              // Removes padding from the modal body
              closable={false}
              style={{
                padding: "0px",
                position: "relative",
              }}
            >
              <div style={{ height: "100%", width: "100%" }}>
                <div style={{ backgroundColor: "#F2F6FB" }}>
                  <h6
                    style={{
                      padding: "10px",
                      fontFamily: "Google Sans, sans-serif",
                    }}
                  >
                    New Message
                  </h6>
                  <button
                    className="custom-close-button"
                    onClick={handleCancelEmail}
                  >
                    {" "}
                    <CloseOutlined />
                  </button>
                </div>

                <div>
                  <div
                    className="custom-menu-email"
                    style={{ padding: "10px" }}
                  >
                    <Select
                      mode="tags"
                      style={{
                        width: "100%",
                      }}
                      placeholder="Recipients"
                      onChange={handleEmailSelect}
                      value={selectedEmails}
                      onInputKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleInputConfirm();
                        }
                      }}
                      onBlur={handleInputConfirm}
                      className="custom-dropdown" // Optional: to style the dropdown menu
                    >
                      {emailOptions.map((email, index) => (
                        <Option key={index} value={email}>
                          {email}
                        </Option>
                      ))}
                    </Select>
                    <br />
                    <br />
                    <Input
                      style={{
                        marginBottom: "10px",
                        border: "none",
                        borderBottom: "1px solid #BFBFBF",
                        borderRadius: "0",
                      }}
                      placeholder="Enter the subject"
                      value={subject}
                      onChange={handleSubjectChange}
                      onMouseOver={(e) =>
                      (e.currentTarget.style.borderBottom =
                        "1px solid #BFBFBF")
                      }
                      onFocus={(e) => (e.currentTarget.style.border = "0px")}
                      onMouseOut={(e) =>
                      (e.currentTarget.style.borderBottom =
                        "1px solid #BFBFBF")
                      }
                    />
                    <br />
                    <div
                      style={{
                        width: "500px",
                        position: "relative",
                        border: "0px",
                      }}
                    >
                      <ReactQuill
                        value={bodyOfEmail}
                        onChange={handleTextArea}
                        placeholder="Content of the body"
                        modules={modules}
                        formats={formats}
                        style={{
                          height: "300px",
                          border: "0px",
                          outline: "none",
                        }} // Remove border and outline
                      />
                      {/* Apply CSS to remove borders from the toolbar and editor */}
                      <style jsx="true">{`
                        .ql-toolbar {
                          position: absolute;
                          bottom: -45px;
                          left: 0;
                          right: 0;
                          width: 100%;
                          display: flex;
                          justify-content: center;
                          border: 0px !important; /* Ensure no border on toolbar */
                        }
                        .ql-container {
                          border: 0px !important; /* Remove border from editor container */
                        }
                        .ql-editor {
                          border: 0px !important; /* Remove border from the editable area */
                          outline: none; /* Remove any outline on focus */
                        }
                      `}</style>
                    </div>

                    <br />
                    <br />
                    <hr />
                    <br />
                    <Button
                      type="primary"
                      onClick={handleOkEmail}
                      style={{
                        borderRadius: "50px",
                        backgroundColor: "#0957D0",
                        borderColor: "#0957D0",
                      }}
                    >
                      Send
                    </Button>
                  </div>
                  <br />
                </div>
              </div>
            </Modal>
          </div>
        )}
        <div
          style={{ color: "#30b5e9", cursor: "pointer" }}
          onClick={() => handleView(data)}
        >
          View
        </div>
      </div>
    </>
  );
};
export default FileInput;
